module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "mapboxMapDiv"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58fd9f63"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/map.vue
// module id = 820
// module chunks = 3